import { createI18n } from "vue-i18n";
import en from "./en.json";
import zh from "./zh.json";

// 获取浏览器语言，设置初始语言
if (!localStorage.getItem("lang")) {
  const browserLanguage = navigator.language.split("-")[0] || "zh";
  localStorage.setItem("lang", browserLanguage);
}

// 创建 i18n 实例
const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem("lang"), // 默认语言
  fallbackLocale: "zh", // 回退语言
  messages: {
    en,
    zh,
  }, // 语言包
});

export default i18n;
